export default __webpack_public_path__ + "static/media/Barret-M82a1-Remote-07.220a228e.jpg";